// Mock data for TEREKA website

export const teamMembers = [
  {
    id: 1,
    name: "Marie Dubois",
    role: "Fondatrice",
    bio: "Passionnée par les échanges culturels, j'ai créé TEREKA pour permettre aux familles de vivre une expérience d'apprentissage unique.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400"
  },
  {
    id: 2,
    name: "Jean Martin",
    role: "Coordinateur",
    bio: "Fort de 10 ans d'expérience dans l'éducation, je m'assure que chaque placement correspond aux attentes de nos familles.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400"
  },
  {
    id: 3,
    name: "Sophie Laurent",
    role: "Responsable des échanges",
    bio: "Je supervise le suivi des anglophones et des familles pour garantir une expérience enrichissante pour tous.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Famille Rousseau",
    location: "Belfort",
    text: "Une expérience formidable ! Nos enfants ont progressé en anglais tout en créant des liens d'amitié exceptionnels avec notre anglophone.",
    rating: 5
  },
  {
    id: 2,
    name: "Famille Petit",
    location: "Territoire de Belfort",
    text: "Plus qu'un simple cours d'anglais, c'est un véritable échange culturel qui a enrichi toute notre famille.",
    rating: 5
  },
  {
    id: 3,
    name: "Sarah Johnson",
    location: "Angleterre",
    text: "J'ai adoré mon séjour avec TEREKA. La famille m'a accueillie chaleureusement et j'ai découvert la belle région de Belfort.",
    rating: 5
  }
];

export const programFeatures = [
  {
    id: 1,
    title: "Durée flexible",
    description: "Programme de 1 à 3 mois selon vos besoins",
    icon: "Calendar"
  },
  {
    id: 2,
    title: "15h par semaine",
    description: "Cours d'anglais, soutien scolaire et conversation",
    icon: "Clock"
  },
  {
    id: 3,
    title: "Immersion totale",
    description: "Logement et repas en famille",
    icon: "Home"
  },
  {
    id: 4,
    title: "Suivi personnalisé",
    description: "Accompagnement de l'association tout au long du séjour",
    icon: "Users"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Comment se déroule la sélection de l'anglophone ?",
    answer: "Nous prenons en compte vos attentes, vos besoins et votre profil familial pour vous proposer un anglophone qui correspond parfaitement à vos critères."
  },
  {
    id: 2,
    question: "Quelle est la durée minimale du programme ?",
    answer: "La durée minimale est d'un mois et peut aller jusqu'à 3 mois maximum. Cela permet de créer une vraie dynamique d'apprentissage."
  },
  {
    id: 3,
    question: "Qui peut participer au programme ?",
    answer: "Toutes les familles du territoire de Belfort et des alentours souhaitant offrir à leurs membres une immersion anglophone enrichissante."
  },
  {
    id: 4,
    question: "Quel est le coût du programme ?",
    answer: "L'échange repose sur le principe du logement et des repas fournis par la famille en contrepartie des 15 heures de cours d'anglais hebdomadaires. L'association facture des frais de mise en relation et de suivi."
  }
];

// Form submission handlers (mock)
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', formData);
      resolve({ success: true, message: 'Merci ! Nous vous répondrons sous 48h.' });
    }, 1000);
  });
};

export const submitRegistrationForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Registration form submitted:', formData);
      resolve({ success: true, message: 'Votre demande a été enregistrée avec succès !' });
    }, 1000);
  });
};